import React from 'react'
import styled from 'styled-components';
import {BookRecommenderResponse} from "./BookRecommenderResponse";
import IndexContentContainer from "../../index/IndexContentContainer";
import Spacer from "../../../common/Spacer";
import NationalityBadge from "../../../common/NationalityBadge";
import RowSpacer from "../../../common/styles/RowSpacer";
import breakpoints from "../../../config/Breakpoints";

const BookRecommenderListRow: React.FC<{
    recommender: BookRecommenderResponse,
    colorType: 'card' | 'card-card'
    href?: string | null;
}> = ({recommender, colorType, href}) => {
    return (
        <IndexContentContainer key={recommender.id}
                               href={href ?? `/community/book-recommendations/${recommender.id}`}
                               backgroundColorType={colorType} isNotHover={true}>
            <Image src={recommender.profileImageUrl}/>

            <ContentContainer>
                <NameAndBadgeContainer>
                    <KoreanName>{recommender.koreanName}</KoreanName>
                    <Spacer/>
                    <NationalityBadge nationality={recommender.nationality}/>
                </NameAndBadgeContainer>

                <SubNameRow>
                    <OriginalName className={'text-secondary'}>{recommender.originalName}</OriginalName>
                </SubNameRow>

                <RowSpacer size={5}/>

                <Description>{recommender.description}</Description>
            </ContentContainer>
        </IndexContentContainer>
    )
}

const Image = styled.img`
    width: 60px;
    height: 60px;
    border-radius: 50%;
`

const KoreanName = styled.h1`
    font-size: 1.4rem;
    margin: 0;
`

const OriginalName = styled.h2.attrs({
    className: 'text-secondary'
})`
    font-size: 1.1rem;
    margin: 0;
`

const SubNameRow = styled.div`
    display: flex;
`

const Description = styled.p.attrs({
    className: 'clamp-1-line'
})`
    margin: 0;
`

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 0;
`

const NameAndBadgeContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`


export default BookRecommenderListRow
